import BaseCard from 'components/Cards/BaseCard';
import { useState } from 'react';
import { Col, Form, Row, Stack } from 'react-bootstrap';
import FloodSettingsField from '../../../../../components/FloodSettingsField/FloodSettingsField';
import { CARD_CLASS_NAMES } from '../../../../../config/floodDeviceConfig';

export default function AdvancedSettingsCard({ deviceSettings, setDeviceSettings, enabled }) {
  const [ipParts, setIpParts] = useState(
    deviceSettings?.ipAddress ? deviceSettings.ipAddress.split('.') : [],
  );

  const handleIpPartChange = (partIndex, newPart) => {
    const newIpParts = [...ipParts];
    newIpParts[partIndex] = newPart;
    setIpParts(newIpParts);
    setDeviceSettings((prev) => ({ ...prev, ipAddress: newIpParts.join('.') }));
  };

  return (
    <BaseCard
      className="shadow-sm bg-primary-shadow text-white border border-danger"
      header="Advanced Settings"
      headerClassName="bg-danger text-white"
      bodyClassName={`d-flex flex-column gap-3 ${CARD_CLASS_NAMES.cardBody}`}
    >
      <p className="text-warning fw-semibold mb-0">
        Do not modify unless directed by RescAlert support.
      </p>

      <Form.Group as={Row} className="align-items-center g-2">
        <Form.Label column lg={5} className="mb-0">
          Destination IP Address
        </Form.Label>
        <Col lg={7}>
          <Stack direction="horizontal" gap={2}>
            {Array.from({ length: 4 }).map((_, index) => (
              <Form.Control
                className={`${CARD_CLASS_NAMES.field} text-center`}
                key={index}
                type="number"
                min={0}
                max={255}
                step={1}
                disabled={!enabled}
                value={ipParts[index] ?? ''}
                onChange={(e) => {
                  const numericValue = Math.min(Math.max(Number(e.target.value) || 0, 0), 255);
                  handleIpPartChange(index, numericValue);
                }}
              />
            ))}
          </Stack>
        </Col>
      </Form.Group>

      <FloodSettingsField
        label="Destination Port"
        type="number"
        step={1}
        disabled={!enabled}
        value={deviceSettings?.port}
        onChange={(e) => setDeviceSettings((prev) => ({ ...prev, port: e.target.value }))}
      />

      <FloodSettingsField
        variant="toggle"
        label="Reboot"
        labelClassName="text-danger fw-semibold"
        id="device-reboot-toggle"
        disabled={!enabled}
        checked={deviceSettings?.reboot}
        onChange={(e) => {
          const value = e.target.checked;
          setDeviceSettings((prev) => ({ ...prev, reboot: value }));
        }}
      />
    </BaseCard>
  );
}
